import { ShellLink } from "@/src/components";
import Translations from "@translate/components/Menu/Logo";
import { AppImage } from "@/src/components/NextImage";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import { useSnapshot } from "valtio";
// import log from "logbeacon";
import { HomeStore } from "@store";
import { ROUTER_PATH } from "@/src/config/router";
import { I18nUtil } from "@utils/i18n";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

export const Logo = (props?: {
  show?: boolean;
  hiddenIcon?: boolean;
  className?: string;
}) => {
  const { isOpen } = useSnapshot(HomeStore);
  const { show, hiddenIcon, className } = props || {};

  const isShow = typeof show === "boolean" ? show : isOpen;

  const handleOpen = () => {
    HomeStore.isOpen = !HomeStore.isOpen;
  };

  return (
    <>
      {isShow && (
        <div
          className={cn(
            "hidden md:flex flex-row items-center justify-between px-5 py-3 cursor-pointer",
            className,
          )}
        >
          <ShellLink
            aria-label="Logo"
            data-openreplay-label={`Logo Link | ${ROUTER_PATH.HOME}`}
            id="lnk-logo"
            href={ROUTER_PATH.HOME}
            className="md:flex h-7 items-center gap-2"
          >
            <AppImage
              width={56}
              height={28}
              alt="edgen-logo"
              className="opacity-100 transition-opacity h-7 w-14"
              src="/edgen_logo_full_v2.svg"
            />
            <span className="body_medium_s text-content_brand_primary shrink-0 rounded-1 border-[0.75px] border-border_brand_transparent50 px-1.5 py-0.5">
              {I18n.t("Beta")}
            </span>
          </ShellLink>
          {!hiddenIcon && (
            <OspIcons
              data-openreplay-label="first-page"
              name="first-page"
              size={20}
              className="text-content_quaternary"
              onClick={handleOpen}
            />
          )}
        </div>
      )}
      {!isShow && (
        <div className="group mx-3 flex justify-center mt-4 cursor-pointer">
          <AppImage
            width={40}
            height={40}
            alt="edgen-logo"
            className="w-10 h-10 opacity-100 transition-opacity group-hover:hidden block"
            src="/assets/images/edgen-logo-v2.svg"
          />
          <div className="rounded-full group-hover:flex hidden p-[10px] w-10 h-10 items-center justify-center bg-background_white_overlay5">
            <OspIcons
              data-openreplay-label="first-page"
              name="first-page"
              size={20}
              className="text-content_quaternary rotate-180"
              onClick={handleOpen}
            />
          </div>
        </div>
      )}
    </>
  );
};
